// extracted by mini-css-extract-plugin
module.exports = {"deliveryModal":"delivery-modal-module--deliveryModal--3LPQE","homeDeliveryIcon":"delivery-modal-module--homeDeliveryIcon--2pd0W"};